import { render, staticRenderFns } from "./businessRecord.vue?vue&type=template&id=9da81092&scoped=true"
import script from "./businessRecord.vue?vue&type=script&lang=js"
export * from "./businessRecord.vue?vue&type=script&lang=js"
import style0 from "./businessRecord.vue?vue&type=style&index=0&id=9da81092&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9da81092",
  null
  
)

export default component.exports